// Utility functions for formatting data

/**
 * Safely format a number to currency with 2 decimal places
 * @param {number|string} value - The value to format
 * @param {string} currency - The currency symbol (default: '$')
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value, currency = 'CHF ') => {
  const numValue = parseFloat(value) || 0;
  return `${currency}${numValue.toFixed(2)}`;
};

/**
 * Safely format a number with specified decimal places
 * @param {number|string} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number string
 */
export const formatNumber = (value, decimals = 2) => {
  const numValue = parseFloat(value) || 0;
  return numValue.toFixed(decimals);
};

/**
 * Safely parse a value to a number
 * @param {any} value - The value to parse
 * @param {number} defaultValue - Default value if parsing fails (default: 0)
 * @returns {number} Parsed number
 */
export const safeParseFloat = (value, defaultValue = 0) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? defaultValue : parsed;
};

/**
 * Safely parse a value to an integer
 * @param {any} value - The value to parse
 * @param {number} defaultValue - Default value if parsing fails (default: 0)
 * @returns {number} Parsed integer
 */
export const safeParseInt = (value, defaultValue = 0) => {
  const parsed = parseInt(value);
  return isNaN(parsed) ? defaultValue : parsed;
};
